import React from "react";
import InnerLayout from "./InnerLayout";

const alumniSidebar = [
  // { label: "Overview", to: "/alumni#overview" },

  // { label: "Registration", to: "/alumni#registration" },
  // { label: "Distinguished Alumni", to: "/alumni#distinguished" },
  { label: "Achievements", to: "/alumni#achievements" },
  // { label: "Meets", to: "/alumni#meets" },
  // { label: "Contributions", to: "/alumni#contributions" },
  // { label: "Mentorship", to: "/alumni#mentorship" },
  { label: "Entrepreneurship", to: "/alumni#entrepreneurship" },
  // { label: "Stories", to: "/alumni#stories" },
  // { label: "Awards", to: "/alumni#awards" },
  // { label: "Give Back", to: "/alumni#give-back" },
  // { label: "Newsletter", to: "/alumni#newsletter" },
];

const dashboardMetrics = [
  ["Registered Alumni", "10,000+"],
  ["Alumni Entrepreneurs", "100+"],
  ["Leadership Roles", "250+"],
  ["Alumni Mentors", "200+"],
  ["Alumni Talks Conducted", "50+"],
  ["Alumni Meets Conducted", "25+"],
  ["International Alumni", "500+"],
];

const associationDetails = [
  ["Association", "KLS VDIT Alumni Association"],
  ["Established", "2008"],
  ["Faculty Coordinator", "Dr. Gururaj Joshi"],
  ["Co-Coordinator", "Dr. Mrs. Plasin F. Dias"],
  ["Executive Committee", "Office bearers and department alumni coordinators"],
  ["Registration", "Batch-wise and department-wise alumni registration"],
  ["Contact", "alumni@klsvdit.edu.in"],
];

const distinguishedAlumni = [
  {
    name: "Mr. Rohan Desai",
    batch: "2012",
    department: "Computer Science & Engineering",
    role: "Senior Engineering Manager",
    organization: "Global FinTech Solutions",
    achievement:
      "Leads distributed engineering teams building secure payment platforms used across international markets.",
  },
  {
    name: "Ms. Ananya Kulkarni",
    batch: "2015",
    department: "Electronics & Communication Engineering",
    role: "Founder & CEO",
    organization: "Astra Embedded Labs",
    achievement:
      "Founded an embedded systems startup supporting IoT automation for manufacturing and agriculture.",
  },
  {
    name: "Mr. Sameer Patil",
    batch: "2010",
    department: "Mechanical Engineering",
    role: "Deputy Project Manager",
    organization: "Infrastructure Development Corporation",
    achievement:
      "Contributes to large-scale infrastructure projects and mentors students interested in public-sector engineering careers.",
  },
];

const achievements = [
  "Alumni have received corporate excellence awards in software, manufacturing, infrastructure, and embedded systems.",
  "Several graduates hold leadership positions in multinational companies, startups, government organizations, and higher education institutions.",
  "Alumni entrepreneurs have founded startups in automation, design services, education technology, consulting, and product engineering.",
  "Research-oriented alumni have contributed to patents, publications, technical innovations, and postgraduate research.",
];

const contributionAreas = [
  "Scholarships and student financial support",
  "Placement support and referral networks",
  "Internship opportunities",
  "Guest lectures and expert talks",
  "Books and learning resources",
  "Laboratory and project guidance",
  "Startup support and business mentoring",
  "Research collaboration and industry connect",
];

const mentorshipTracks = [
  ["Career Guidance", "Career planning, role discovery, and industry readiness sessions."],
  ["Placement Mentoring", "Mock interviews, resume review, aptitude support, and company-specific preparation."],
  ["Higher Education", "Guidance for GATE, GRE, IELTS, admissions, scholarships, and research pathways."],
  ["Entrepreneurship", "Startup validation, founder talks, incubation support, and investor connects."],
  ["Technical Mentoring", "Project reviews, industry project ideas, tools, platforms, and best practices."],
  ["Competitive Exams", "Planning support for public-sector, banking, and technical recruitment exams."],
];

const entrepreneurshipItems = [
  "Alumni startup founder directory",
  "Startup profiles and founder journeys",
  "Incubation and product validation support",
  "Investor and customer connection opportunities",
  "Founder talks and startup mentoring",
  "Alumni business network for collaboration",
];

const storyCards = [
  {
    title: "From Campus Project to Product Team",
    text:
      "An alumnus from the CSE department returned to share how a final-year project became the foundation for a career in product engineering.",
  },
  {
    title: "Building a Startup After Graduation",
    text:
      "A young entrepreneur from E&CE spoke about customer discovery, early hiring, and the discipline needed to build hardware products.",
  },
  {
    title: "Higher Education Abroad",
    text:
      "International alumni guide students on applications, statements of purpose, assistantships, and adapting to global classrooms.",
  },
];

const awards = [
  "Distinguished Alumni Award",
  "Young Alumni Achiever Award",
  "Alumni Entrepreneur Award",
  "Alumni Research Excellence Award",
  "Social Impact Award",
  "Alumni Service Award",
  "Lifetime Achievement Award",
];

const giveBackOptions = [
  "Support student projects",
  "Offer internships",
  "Conduct expert talks",
  "Mentor students",
  "Support placements",
  "Sponsor academic and cultural events",
];

const SectionTitle = ({ id, eyebrow, title, children }) => (
  <section id={id} className="scroll-mt-32">
    {eyebrow && (
      <p className="text-xs uppercase tracking-[0.24em] text-brand font-semibold mb-2">
        {eyebrow}
      </p>
    )}
    <h2
      className="text-3xl md:text-4xl text-brand font-semibold mb-4"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      {title}
    </h2>
    {children}
  </section>
);

const Alumni = () => (
  <InnerLayout
    title="Alumni"
    image="/Campus/Alumnihero.jpeg"
    breadcrumbs={[{ label: "Alumni" }]}
    sidebar={alumniSidebar}
    sidebarTitle="Alumni"
  >
    <div className="space-y-14">
      <SectionTitle id="overview" eyebrow="Alumni Overview" title="A Network That Carries VDIT Forward">
        <div className="vdit-prose">
          <p>
            The KLS VDIT Alumni Association connects graduates across batches,
            departments, industries, and geographies. The network strengthens
            the bond between alumni and the institution while creating
            opportunities for students to learn from real professional journeys.
          </p>
          <p>
            Alumni contribute to institutional growth through mentoring,
            placement support, internships, guest lectures, research
            collaboration, entrepreneurship guidance, and participation in
            academic and developmental initiatives.
          </p>
        </div>
      </SectionTitle>

      <SectionTitle id="dashboard" eyebrow="Alumni Dashboard" title="Alumni at a Glance">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-12 gap-y-6 bg-[#f4ecdf] px-4 py-5 md:px-6">
          {dashboardMetrics.map(([label, value]) => (
            <div key={label} className="min-w-0">
              <div
                className="text-2xl md:text-[26px] leading-none text-[#7a1d2c] font-semibold"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {value}
              </div>
              <div className="text-[11px] uppercase tracking-wide text-[#2a2a2a]/80 mt-2 font-sans-ui">
                {label}
              </div>
            </div>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="association" eyebrow="Alumni Association" title="Association and Coordination">
        <p className="text-[#2a2a2a]/85 leading-relaxed mb-5">
          The association works with office bearers, faculty coordinators, and
          department alumni coordinators to maintain alumni records, organize
          events, support student engagement, and build long-term institutional
          relationships.
        </p>
        <div className="overflow-x-auto bg-white border border-brand/15">
          <table className="min-w-full text-sm">
            <tbody>
              {associationDetails.map(([label, value]) => (
                <tr key={label} className="border-t border-brand/10 first:border-t-0">
                  <td className="px-4 py-3 font-semibold text-brand w-56">{label}</td>
                  <td className="px-4 py-3 text-[#2a2a2a]/85">{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </SectionTitle>

      <SectionTitle id="registration" eyebrow="Alumni Registration" title="Stay Connected With Your Batch and Department">
        <div className="grid md:grid-cols-3 gap-4">
          {[
            ["Register", "Join the alumni database with batch, department, contact, and professional details."],
            ["Update Profile", "Keep your role, organization, location, and areas of interest current."],
            ["Engage", "Opt in for mentoring, talks, internships, placements, entrepreneurship, or reunions."],
          ].map(([title, text]) => (
            <div key={title} className="bg-white border border-brand/15 p-5">
              <h3 className="text-xl text-brand font-semibold">{title}</h3>
              <p className="text-[#2a2a2a]/85 mt-2">{text}</p>
            </div>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="distinguished" eyebrow="Distinguished Alumni" title="Profiles of Achievement">
        <div className="grid lg:grid-cols-3 gap-5">
          {distinguishedAlumni.map((alumnus) => (
            <article key={alumnus.name} className="bg-white border border-brand/15 p-5">
              <div className="h-16 w-16 bg-brand/10 text-brand flex items-center justify-center text-2xl font-semibold mb-4">
                {alumnus.name
                  .split(" ")
                  .filter(Boolean)
                  .slice(0, 2)
                  .map((part) => part[0])
                  .join("")}
              </div>
              <h3 className="text-xl text-brand font-semibold">{alumnus.name}</h3>
              <p className="text-sm text-[#2a2a2a]/70 mt-1">
                Batch {alumnus.batch} | {alumnus.department}
              </p>
              <p className="text-sm font-semibold text-[#2a2a2a] mt-3">
                {alumnus.role}, {alumnus.organization}
              </p>
              <p className="text-[#2a2a2a]/85 mt-3">{alumnus.achievement}</p>
            </article>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="achievements" eyebrow="Alumni Achievements" title="Recognition Across Fields">
        <div className="grid md:grid-cols-2 gap-3">
          {achievements.map((achievement) => (
            <div key={achievement} className="bg-white border border-brand/15 p-4 text-[#2a2a2a]/85">
              {achievement}
            </div>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="meets" eyebrow="Alumni Meets and Reunions" title="Reconnecting With the Campus">
        <div className="grid md:grid-cols-3 gap-4">
          {[
            ["Annual Alumni Meet", "A campus gathering for alumni interaction, student networking, recognition, and institutional updates."],
            ["Batch Reunions", "Department and batch-wise reunions help alumni revisit memories and reconnect with faculty and classmates."],
            ["Event Reports", "Photo galleries and reports document alumni talks, reunions, mentoring sessions, and association activities."],
          ].map(([title, text]) => (
            <div key={title} className="bg-white border border-brand/15 p-5">
              <h3 className="text-xl text-brand font-semibold">{title}</h3>
              <p className="text-[#2a2a2a]/85 mt-2">{text}</p>
            </div>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="contributions" eyebrow="Alumni Contributions" title="Support That Strengthens Students">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {contributionAreas.map((area) => (
            <div key={area} className="bg-white border border-brand/15 px-4 py-3 text-[#2a2a2a]/85">
              {area}
            </div>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="mentorship" eyebrow="Alumni Mentorship" title="Guidance From People Who Have Walked the Path">
        <div className="grid md:grid-cols-2 gap-4">
          {mentorshipTracks.map(([title, text]) => (
            <div key={title} className="bg-white border border-brand/15 p-5">
              <h3 className="text-xl text-brand font-semibold">{title}</h3>
              <p className="text-[#2a2a2a]/85 mt-2">{text}</p>
            </div>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="entrepreneurship" eyebrow="Entrepreneurship Network" title="Alumni Founders and Business Connect">
        <p className="text-[#2a2a2a]/85 leading-relaxed mb-5">
          The entrepreneurship network brings together alumni founders,
          business leaders, mentors, and aspiring student entrepreneurs for
          startup conversations, founder talks, and collaboration.
        </p>
        <div className="flex flex-wrap gap-2">
          {entrepreneurshipItems.map((item) => (
            <span key={item} className="bg-[#f4ecdf] border border-brand/10 px-3 py-2 text-sm">
              {item}
            </span>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="stories" eyebrow="Stories and Testimonials" title="Journeys Worth Sharing">
        <div className="grid md:grid-cols-3 gap-4">
          {storyCards.map((story) => (
            <article key={story.title} className="bg-white border border-brand/15 p-5">
              <h3 className="text-xl text-brand font-semibold">{story.title}</h3>
              <p className="text-[#2a2a2a]/85 mt-2">{story.text}</p>
            </article>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="awards" eyebrow="Awards and Recognition" title="Celebrating Alumni Excellence">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {awards.map((award) => (
            <div key={award} className="bg-white border border-brand/15 px-4 py-3 text-[#2a2a2a]/85">
              {award}
            </div>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="give-back" eyebrow="Give Back to Institution" title="Ways Alumni Can Contribute">
        <div className="grid md:grid-cols-3 gap-4">
          {giveBackOptions.map((option) => (
            <div key={option} className="bg-white border border-brand/15 p-5 text-[#2a2a2a]/85">
              {option}
            </div>
          ))}
        </div>
      </SectionTitle>

      <SectionTitle id="newsletter" eyebrow="Newsletter and Publications" title="Alumni Updates and Publications">
        <div className="bg-white border border-brand/15 p-5">
          <p className="text-[#2a2a2a]/85 leading-relaxed">
            The alumni newsletter and publications section will carry alumni
            magazine updates, event reports, batch updates, reunion highlights,
            and stories from graduates across departments.
          </p>
          <p className="text-sm text-[#2a2a2a]/70 mt-4">
            Department alumni coordinators may share verified alumni updates,
            stories, photographs, and achievements for publication.
          </p>
        </div>
      </SectionTitle>
    </div>
  </InnerLayout>
);

export default Alumni;
